<template>
	<main-layout>
   
		<div class="">
      <br>
			<div class="has-text-centered getMainDiv container top40">
			<!-- 	<H1 class="has-text-light is-size-3">Get Slinks</H1> -->
        <br>
			

        <img class="ownYourWordsImg" src="@/assets/img/ownyourwordsyellow.png" width="150"/>
        <br>

      

        <div v-show="showNotAvail" class="bandSearch  bottom20 top40 has-text-black">Sorry, the slink <b>"{{msgSlink}}"</b> is taken.</div>

				<div class="is-size-4 top30 has-text-black">
				<div class="band">	<span class="isPoppins has-text-white"><b>Enter the slink you would like to reserve to get started:</b></span></div>
      
           <div class="is-size-5 has-text-white top10">(It can be a word or short phrase with no spaces)</div>
				</div>

        <div class="is-inline-block ">
          <get-started ref="gs" :get="true"></get-started>
        </div>
       


			<!-- 	<form @submit.prevent="submit" class="top20">
					<input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" id="slinkField"  class="input mainInput getInput limitWidth is-warning bottom10" type="text" style="border-radius: 15px; text-transform: lowercase"  v-model="slink" v-validate="'required'" name="slink" />
					<button id="getSlinkButt" type="submit" class="button is-warning">CHECK</button>
           <sr></sr>
				</form> -->
        <br>
			</div>

     
		</div>


   <div class="slantedDiv has-background-darkTurk top160">
      <div class="   has-text-centered">
       
         
            <!-- PRICING PLANS -->
  
          <div class="container has-text-left">
              <div class="is-size-3 has-text-white "><img src="@/assets/img/chevronsY.png" width="27" /><b class="left3">Pricing</b></div>
                        <div class="has-text-yell is-size-4 top20"><b>Try 30 days for free</b> (no credit card)</div>
                        <div v-if="$root.showPlans" class="columns top20 mobileMargin pricingBG"  data-aos="fade-left">
                            <div class="column top20">
                                <div class="has-text-centered planPanel">
                                    <div class="planTitleHome"><b>BASIC</b></div>
                                    <div class="top40">
                                        <div class="is-size-3"><b>Slink + <span class="has-text-yell">{{$root.newPlans.SmallYearly.limit}} subslinks</span ></b></div>
                                        <div class="is-size-6 top5"><b>-</b></div>
                                        <div class="is-size-6 top5"><b>SlinkPage</b></div>
                                        <div class="is-size-6 top5"><b>QR codes</b></div>
                                        <div class="is-size-6 top5">2 million redirects per year</div>
                                        <div class="is-size-4 top40 priceContainer">$<b>{{$root.newPlans.SmallMonthly.price}}</b>/mth <br><span class="is-size-6">or</span ><br>$<b>{{$root.newPlans.SmallYearly.price}}</b>/yr</div>
                                        <br>
                                    </div>
                                </div>
                            </div>
                            <div class="column top20">
                                <div class="has-text-centered planPanel">
                                    <div class="planTitleHome"><b>STANDARD</b></div>
                                    <div class="top40">
                                        <div class="is-size-3"><b>Slink + <span class="has-text-yell">{{$root.newPlans.MediumYearly.limit}} subslinks</span></b></div>
                                        <div class="is-size-6 top5"><b>Analytics</b></div>
                                        <div class="is-size-6 top5"><b>SlinkPage</b></div>
                                        <div class="is-size-6 top5"><b>QR codes</b></div>
                                        <div class="is-size-6 top5">3 million redirects per year</div>
                                        <div class="is-size-4 top40 priceContainer">$$<b>{{$root.newPlans.MediumMonthly.price}}</b>/mth <br><span class="is-size-6">or</span ><br>$<b>{{$root.newPlans.MediumYearly.price}}</b>/yr</div>
                                        <br>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="column top20">
                                <div class="has-text-centered planPanel">
                                    <div class="planTitleHome"><b>PREMIUM</b></div>
                                    <div class="top40">
                                        <div class="is-size-3"><b>Slink + <span class="has-text-yell">{{$root.newPlans.LargeYearly.limit}} subslinks</span></b></div>
                                        <div class="is-size-6 top5"><b>Analytics</b></div>
                                        <div class="is-size-6 top5"><b>SlinkPage</b></div>
                                        <div class="is-size-6 top5"><b>QR codes</b></div>
                                        <div class="is-size-6 top5">5 million redirects per year</div>
                                        <div class="is-size-4 top40 priceContainer">$$<b>{{$root.newPlans.LargeMonthly.price}}</b>/mth <br><span class="is-size-6">or</span ><br>$<b>{{$root.newPlans.LargeYearly.price}}</b>/yr</div>
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="has-text-white is-size-4 has-text-centered top20"><b>Your account may hold as many Slinks as you like</b></div>
                        <div class="has-text-white is-size-5 has-text-centered top30">*Please contact us for corporate plans with higher subslink counts</div>
                        <div class="has-text-white is-size-6 has-text-centered top5">Review the Terms and Conditions for details about subscription plans</div>
                        <br> <br> <br> <br>
                      </div>
      </div>
   </div>
       
     
  

  <!-- <div class="angleBGget has-background-primary"></div>
   <div class="angleCoverGet has-background-primary"></div> -->
    
	</main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import  constants  from '../STATIC/constants.js'
import sr from '../components/SearchResults.vue'
import GetStarted from '../components/GetStarted.vue'

export default {
  data: function () {
    var slink = '',
      slink2 = '',
      showAvail = false,
      showNotAvail = false

    return {
      slink: slink,
      slink2: slink2,
      showAvail: showAvail,
      showNotAvail: showNotAvail,
      msgSlink: '',
      constants
    }
  },
  components: {
    MainLayout,
    sr,
    GetStarted
  },
  mounted: function(){
    document.getElementById('slinkField').onkeypress = function(event){
      var regex = /[^a-zA-Z0-9\@_-]/g;
      if(String.fromCharCode(event.key.charCodeAt()).match(regex)){ //az.findInArr(constants.PREVENTEDCHRS, event.key.charCodeAt())
          event.preventDefault();
      }
    }
  },
  methods: {
    submit: function () {
      // TODO wire this into API via ajax!
      this.showAvail = false
      this.showNotAvail = false
      this.$root.showSlinkAvail = false

      this.$validator.validateAll().then((res) => {
        if (res) {
          var self = this

          az.addRemSpinner(true, 'id', 'goSlinkButt');
          self.worked = function (data) {

						az.addRemSpinner(false, 'id', 'goSlinkButt');
            var obj = data
            if (obj.e == 'snf' || obj.e == 'spp') {
              if (self.$root.checkSlinkInCart(obj.slink)) {
                self.$root.showModalOK({ message: 'This slink is available and is already in your cart.' })
                return
              } else if(obj.e == 'spp') {
                self.$root.showModalOK({ message: 'This slink is in the process of being purchased by another user. It may become available later if that purchase is not completed.' })
                return
              }
              self.$root.slink = obj.slink
              self.$root.showSlinkAvail = true
    
            } else if(obj.e == 'prtd'){
              self.$root.doShowModal(ModalClaims, {slink: obj.slink})
              //self.$root.showModalOK({message: 'This word or phrase is available but protected by trademark. If you own the trademark and would like to claim it, please contact claims@slink.com'})
            } else if(obj.e == 'prtdwrd'){
              self.$root.doShowModal(ModalClaims, {slink: obj.slink, wordVariant: true})
              //self.$root.showModalOK({message: 'This word or phrase is available but protected by trademark. If you own the trademark and would like to claim it, please contact claims@slink.com'})
            } else {
              self.showNotAvail = true
              self.msgSlink = self.slink
            }

            //self.msgSlink = ''
            self.slink = ''


          }
          self.noWorked = function () {
            az.addRemSpinner(false, 'id', 'goSlinkButt');
            self.$root.showModalOK({message: 'Sorry, there was en error processing your request.'})
          }
          self.$root.apiClient.get('api/slink/' + encodeURIComponent(self.slink.toLowerCase()), {}, self.worked, self.noWorked)
        }
      })
    },
    noAdd: function () {
      this.showAvail = false
    },
    addToCart: function () {
      this.$root.slink = this.slink2
      this.$root.addToCart('slink', this.slink2, constants.SLINK_YEARLY_PLAN.plan)
      this.showAvail = false
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/pages/Get.vue